import { Component, Inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { slideInAnimation } from './core/models/animations';
import { MatDialog } from '@angular/material/dialog';
import { AdminService } from './core/services/admin-apis/admin.service';
import * as moment from 'moment-timezone';
import { MixpanelService } from './shared/service/mix-panel.service';
import { ZendeskService } from './shared/service/zendesk.service';
import { AuthenticationService } from './core/services/Authentication/authentication.service';
import { UserDetailsService } from './core/services/user-details/user-details.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  animations: [
    slideInAnimation
  ]
})
export class AppComponent implements OnInit{
  title = 'creatics-ui';
  currentTimezone :any
  dbTimezone: any; // last user timezone stored in database
  @ViewChild('dialogTemplate') dialogTemplate: TemplateRef<any>;

  constructor(  private service: AdminService,
                private dialog: MatDialog, 
                private router: Router,
                private mixpanelService:MixpanelService,
                private zenDeskService:ZendeskService,
                private authService:AuthenticationService,
                private userDetailsService: UserDetailsService,
                
    ){}
  prepareRoute(outlet: RouterOutlet): any {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData.animation;
  }

  ngOnInit(): void {
    this.zenDeskService.loadWidget();
    this.setZendeskLoginDetailsOnReload();
    this.mixpanelService.traceUser();
    this.currentTimezone = moment.tz.guess();       
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    const countryCode = userTimezone.includes("America") ? "US" : userTimezone;
    const local = localStorage.getItem("userCountry")
    if(!local || (local !== countryCode)){
    localStorage.setItem("userCountry", countryCode);    
  }
    if(window.location.pathname !== "/admin-console"){
      this.service.getCreaticsHomepageLoggedIn().subscribe(data => {

        this.dbTimezone = data.timezone

        if(data.userId){
          if(this.currentTimezone !== this.dbTimezone){
            
            this.service.updateTimezone(this.currentTimezone).subscribe(res =>{

            },
          (err => {
          }))
          
          }
        }

        if (data.hasNotification) {

          const dialogRef = this.dialog.open(this.dialogTemplate, {
            disableClose: true,
            data: {
                title: data.notification.title,
                description: data.notification.description,
                link: data.notification.link
            }
          });

          dialogRef.afterClosed().subscribe(result => {

          });

        }

      })
    }
  }
  setZendeskLoginDetailsOnReload(){
    this.authService.checkUserAuthenticated().subscribe(
      (res) => {
        if (res.userId > 0){
           this.userDetailsService.getUserDetails(res.userId).subscribe({
            next:(res: any) => {
            let name =  res.firstName + " "+ res.lastName;
            let email = res.emailAddress;
            this.zenDeskService.setUserIdentity(res.userId,name,email);
          },
          error:(err)=>{
            console.log(err)}
          }
        )
        }
      }
    )
  }
 
}
